import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, withTheme, useTheme } from '@mui/styles';

import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';

import { ColorButton } from '../colorselector';

import {
    blue,
    pumpkin,
    purple,
    orange,
    teal,
    olive,
    skyBlue,
    lavender,
    pointlessPuple,
    yellow,
    red,
    pointlessPink,
    normal,
    warning,
    critical,
    neutrals1,
    neutrals2
} from '../../data/colors.js';
import icons from '../../data/json/icons.json';
const iconkeys = Object.keys(icons);

const styles = theme => ({
    divider: {
        height: 1,
    },
    colors: {
        flexWrap: 'wrap',
        overflowY: 'scroll',
        overflowX: 'clip',
    },
    colorrow: {
        display: 'flex',
        '& button': {
            margin: 4,
        },
    },
    icons: {
        paddingRight: 0,
        paddingTop: 0,
        flexWrap: 'wrap',
        overflowY: 'scroll',
    },
    selected: {
        borderColor: `${theme.palette.text.primary} !important`,
        borderStyle: 'solid !important',
        borderWidth: '2px !important',
        width: '15px !important',
        height: '15px !important',
    },
    iconButton: {
        // margin: 4,
        '& .MuiIcon-root': {
            fontSize: 'inherit',
        }
    },
    searcinput: {
        width: '75%',
    }
});

class TagEditor extends PureComponent {
    constructor (props) {
        super(props);
        // const { theme } = this.props;
        this.state = {
            search: '',
            colors: [
                Object.values(blue).slice(0, 9),
                Object.values(pumpkin).slice(0, 9),
                Object.values(purple).slice(0, 9),
                Object.values(orange).slice(0, 9),
                Object.values(teal).slice(0, 9),
                Object.values(olive).slice(0, 9),
                Object.values(skyBlue).slice(0, 9),
                Object.values(lavender).slice(0, 9),
                Object.values(pointlessPuple).slice(0, 9),
                Object.values(yellow).slice(0, 9),
                Object.values(red).slice(0, 9),
                Object.values(pointlessPink).slice(0, 9),
                [
                    normal, warning, critical,
                    ...Object.values(neutrals1).slice(0, 3),
                    ...Object.values(neutrals2).slice(0, 3),
                ],
            ],
        };
        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    handleSearchChange (event) {
        this.setState({ search: event.target.value });
    }

    handleSelectColor (event, c) {
        this.props.onSelectColor && this.props.onSelectColor(c);
        event.stopPropagation();
    }

    handleSelectIcon (event, icn) {
        this.props.onSelectIcon && this.props.onSelectIcon(icn);
        event.stopPropagation();
    }

    render () {
        const { classes, icon, height, color } = this.props;
        const { search, colors } = this.state;
        return (
            <React.Fragment>
                <MenuItem className={classes.colors} style={{ maxHeight: height / 2 }}>
                    {colors.map((row, j) =>
                        <div className={classes.colorrow} key={`colorrow-${j}`}>
                            {row.map((c, i) =>
                                <ColorButton
                                    key={`${c}_${i}`}
                                    color={c}
                                    style={{ margin: 2 }}
                                    onClick={(event) => this.handleSelectColor(event, c)}
                                    selected={color} />
                            )}
                        </div>
                    )}
                </MenuItem>
                <Divider className={classes.divider} orientation="horizontal" />
                <IconButton
                    className={classes.iconButton}
                    disabled={!search}
                    aria-label="search icons"
                    size="large">
                    <SearchIcon />
                </IconButton>
                <InputBase
                    className={classes.searcinput}
                    onChange={this.handleSearchChange}
                    value={search}
                    placeholder={'Search icons'}
                    inputProps={{ 'aria-label': 'Search icons', spellCheck: false }}/>
                <MenuItem className={classes.icons} style={{ maxHeight: height / 2 }}>
                    {iconkeys
                        .filter(icn => !search.length || icn.includes(search))
                        .map((icn, i) =>
                            <IconButton
                                className={classes.iconButton}
                                key={icn}
                                style={{ color: icn === icon ? color : '' }}
                                size="small"
                                aria-label="tag icon"
                                title={icn}
                                onClick={(event) => this.handleSelectIcon(event, icn)}>
                                <Icon fontSize="inherit">{icn}</Icon>
                            </IconButton>
                        )}
                </MenuItem>
            </React.Fragment>
        );
    }
}

TagEditor.propTypes = {
    color: PropTypes.string,
    icon: PropTypes.string,
    onSelectIcon: PropTypes.func,
    onSelectColor: PropTypes.func,
    classes: PropTypes.object,
    height: PropTypes.number.isRequired,
    // theme: PropTypes.object,
};

export const RandomIcon = () => iconkeys[Math.floor(Math.random() * iconkeys.length)];

export const RandomColor = () => {
    const theme = useTheme();
    const colors = [...theme.SeverityColors, ...theme.ChartColors];
    return colors[Math.floor(Math.random() * colors.length)];
};

export default withTheme(withStyles(styles)(TagEditor));
